'use strict';

var debug = require('debug');

function createLogger(name) {
  var logger = debug(name);

  return function (message) {
    logger(message);
  };
}

module.exports = createLogger;